<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.search_token">
  <div *ngIf="isTitle">
    <span>{{localService.languageContent.search_token.search_with_token}}</span>
  </div>
  <div style="margin-top: -15px;">
    <input autocomplete="off" style="width:150px;background-color:transparent"
      *ngIf="todayTokenDate && !isShowAcceptanceSerailNumberInViewBill" type="text" class="number"
      [ngClass]="tokenDate ? 'en' : ''" [(ngModel)]="tokenDate" (blur)="onValidate(1)"
      (keydown.enter)="localService.onFocusNextInput(elementIds.txt_token_num, 1)" />
    <span class="en" *ngIf="!isShowAcceptanceSerailNumberInViewBill">-</span>
    <input autocomplete="off" style="width:45px;background-color:transparent"
      [ngStyle]="{'width' : (isShowAcceptanceSerailNumberInViewBill? '100':'45')+'px'}"
      id="{{elementIds.txt_token_num}}" (blur)="onValidate(isEmitOnBlur ? 3 : (currentId == '' ? 2 : 0))" type="number"
      [ngClass]="tokenNumber ? 'en' : ''" [(ngModel)]="tokenNumber" (keydown.enter)="onGetToken()"
      (input)="onGetToken(false)" />
    <button class="button_icon button_icon_color footer_icon" [ngStyle]="{'top' : iconTopAdjust + 'px'}"
      (click)="onGetToken()">
      search
    </button>
  </div>
  <div *ngIf="message != ''" [ngStyle]="{'color' : isTokenAvailable ? 'green' : 'red'}">
    {{message}}
  </div>
  <span style="display: none;">
    <button class="after_access_check" (click)="onLoad()">After Access Check</button>
  </span>
</div>